// Product page: running total under the quantity ("Total: 60 kg · 780,00 lei"),
// from the selected variant's price and weight, which Dawn re-renders inside
// #AqPricePerKg-<section> on every variant change.
(() => {
  if (customElements.get('aq-bag-total')) return;

  function formatMoney(cents, format) {
    const value = Number(cents) / 100;
    const group = (num, decimals, thousands, decimal) => {
      const [whole, frac] = num.toFixed(decimals).split('.');
      const withSep = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + decimal + frac : withSep;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_with_comma_separator') return group(value, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return group(value, 0, '.', ',');
      if (key === 'amount_no_decimals') return group(value, 0, ',', '.');
      return group(value, 2, ',', '.');
    });
  }

  class AqBagTotal extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.input = document.getElementById(`Quantity-${this.section}`);
      this.onChange = () => this.update();
      this.input?.addEventListener('change', this.onChange);
      this.input?.addEventListener('input', this.onChange);
      // Dawn's pub/sub helpers are top-level script globals, not window properties.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.section) setTimeout(this.onChange, 50);
        });
      }
      this.update();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onChange);
      this.input?.removeEventListener('input', this.onChange);
      this.unsubscribe?.();
    }

    update() {
      const variant = document.querySelector(`#AqPricePerKg-${this.section} [data-aq-variant]`);
      const quantity = Math.max(1, parseInt(this.input?.value, 10) || 1);
      if (!variant) return;
      const price = Number(variant.dataset.price);
      const weight = Number(variant.dataset.weight);
      if (weight < 5000 || quantity < 2) {
        this.textContent = '';
        return;
      }
      const kg = (weight * quantity) / 1000;
      this.textContent = this.dataset.template
        .replace('[kg]', Number.isInteger(kg) ? kg : kg.toFixed(1).replace('.', ','))
        .replace('[price]', formatMoney(price * quantity, this.dataset.moneyFormat));
    }
  }

  customElements.define('aq-bag-total', AqBagTotal);
})();
